<template>
  <div class="card col-md-6 mx-md-auto col-lg-3 px-0 ml-0">
    <div class="sombra mr-0" :class="!margenDerecho ? 'mr-md-3' : ''">
      <div
        class="card-header row mx-0"
        :style="
          'background-color: ' + carrera.institucion.pantone + '; color: #FFF;'
        "
      >
        <AñoAcreditacion
          v-if="carrera.institucion.acreditado"
          :acreditacion="carrera.institucion.acreditacion"
          divClass="col-2 icon mt-0 mr-0 px-0 text-center"
        />
        <div
          class="col-10 tit-instt px-0"
          v-b-tooltip.hover
          :title="carrera.institucion.nombre"
        >
          {{ carrera.institucion.nombreCorto }}
        </div>
      </div>
      <div class="card-body" @click="verFichaCarrera">
        <div class="cabezal">
          <h5
            class="card-title text-center"
            v-b-tooltip.hover
            :title="carrera.datos.nombre"
          >
            {{ carrera.datos.nombre }}
          </h5>
          <p class="card-text text-muted text-center">
            {{ textoSede }}
            <br />
            {{ textoRegion }}
          </p>
        </div>
        <Iconos
          :jornada="carrera.datos.jornada"
          :postulacion="carrera.datos.estadoPostulacion"
        />
        <table class="table table-borderless table-sm col-12 my-2 mx-auto">
          <tbody>
            <tr>
              <th scope="col text-left" colspan="2">
                <h6>Título:</h6>
                <br />
                <span
                  class="mb-2"
                  v-b-tooltip.hover
                  :title="carrera.datos.titulo"
                  >{{ carrera.datos.titulo }}</span
                >
              </th>
            </tr>
            <tr>
              <th scope="col text-left">
                <h6>Vacantes {{ anioVacanteTP }}:</h6>
              </th>
              <td scope="col" class="text-right">
                {{ carrera.datos.vacantes }}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <h6>Matrícula {{ anioMatriculaTP }}:</h6>
              </th>
              <td scope="col" class="text-right">
                {{
                  formatearArancelMatricula(
                    carrera.datos.costoMatriculaAnual,
                    carrera.datos.tipoMoneda
                  )
                }}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <h6>Arancel {{ anioArancelTP }}:</h6>
              </th>
              <td scope="col" class="text-right">
                {{
                  formatearArancelMatricula(
                    carrera.datos.arancelAnual,
                    carrera.datos.tipoMoneda
                  )
                }}
              </td>
            </tr>
            <tr>
              <th scope="row">
                <h6>Duración:</h6>
              </th>
              <td scope="col" class="text-right">{{ textoDuracion }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer mx-0 mb-1 d-flex">
        <span
          @click="contactame"
          class="btn btn-secondary mr-auto"
          type="button"
          v-b-tooltip.hover
          title="Solicita que te envíen más información sobre esta carrera"
        >
          <FontAwesomeIcon icon="envelope" />
          <small class="ml-2">Contáctenme</small>
        </span>
      </div>
      <div class="card-footer mx-0 d-flex">
        <span
          @click="verFichaCarrera"
          class="btn btn-secondary mr-auto"
          type="button"
          v-b-tooltip.hover
          title="Ver más información sobre esta carrera"
        >
          <FontAwesomeIcon icon="plus-circle" />
          <small class="ml-2">Ver más</small>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import AñoAcreditacion from "@/components/generales/iconos/AñoAcreditacionBlanco";
import Iconos from "@/components/generales/iconos/IconosTarjeta";
import Busqueda from "@/utils/Busqueda.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { ModalContactoTP } from "@/utils/BusesDeEventos.js";
import MixinArancelMatricula from "@/mixins/FormatearArancelMatricula.js";
library.add(faEnvelope);
export default {
  name: "TarjetaCarrera",
  mixins: [MixinArancelMatricula],
  props: {
    carrera: {
      type: Object
    },
    margenDerecho: {
      type: Boolean
    }
  },
  components: {
    AñoAcreditacion,
    Iconos,
    FontAwesomeIcon
  },
  computed: {
    gratuidad() {
      return this.carrera.institucion.gratuidad
        ? "Adscrita a Gratuidad"
        : "Gratuidad no disponible";
    },
    textoDuracion() {
      if (
        this.carrera.datos.duracionFormalPrograma &&
        this.carrera.datos.regimen
      ) {
        return `${
          this.carrera.datos.duracionFormalPrograma
        } ${this.carrera.datos.regimen
          .charAt(0)
          .toUpperCase()}${this.carrera.datos.regimen.slice(1).toLowerCase()}`;
      } else {
        return "No disponible";
      }
    },
    textoSede() {
      if (this.carrera.datos.jornada === "A_DISTANCIA") {
        return "Aula Virtual";
      } else {
        return this.carrera.sede.nombre;
      }
    },
    textoRegion() {
      if (this.carrera.datos.jornada === "A_DISTANCIA") {
        return "-";
      } else {
        return this.limpiarNombreRegion(this.carrera.sede.region);
      }
    }
  },
  methods: {
    limpiarNombreRegion(region) {
      return Busqueda.limpiarNombreRegionSimble(region);
    },
    verFichaCarrera() {
      this.$router.push({
        name: "FichaCarrera",
        params: {
          idInstitucion: this.carrera.institucion.codigo,
          codigoCarrera: this.carrera.datos.codigo,
          origen: "BuscadorTP"
        }
      });
    },
    contactame() {
      let datosContacto = {
        codigoIntitucion: this.carrera.institucion.codigo,
        codigoSede: this.carrera.sede.codigo,
        codigoCarrera: this.carrera.datos.codigo
      };
      ModalContactoTP.$emit("contactameTP", datosContacto);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/buscadorTP/TarjetaCarrera.vue